/*!
 * Replaces placeholders with real content
 * Requires get() - https://vanillajstoolkit.com/helpers/get/
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {String} template The template string
 * @param {String} local    A local placeholder to use, if any
 */
const getPlaceholders = (template): string[] => {
  // Check if the template is a string or a function
  template = typeof template === 'function' ? template() : template;
  if (['string', 'number'].indexOf(typeof template) === -1) {
    throw new Error('PlaceholdersJS: please provide a valid template');
  }

  const matches: string[] = [];
  // Replace our curly braces with data
  template = template.replace(/\{\{([^}]+)\}\}/g, (match) => {
    matches.push(match);
  });

  return matches;
};

export default getPlaceholders;
